import { translation, formatToReactComponent, TranslatedComponent } from '@hh.ru/front-static-app';
import { Text, useBreakpoint } from '@hh.ru/magritte-ui';

import HumanDate from 'src/components/HumanDate';

const TrlKeys = {
    expire: 'hhpro.promo.state.active.description',
    canceled: 'hhpro.promo.state.cancel.complete',
};

const Expire: TranslatedComponent<{ expiredAt?: string; canceled?: boolean }> = ({ trls, canceled, expiredAt }) => {
    const breakpoint = useBreakpoint();

    const typography = breakpoint.isGtS ? 'label-2-regular' : 'label-3-regular';

    if (!expiredAt) {
        return null;
    }
    return (
        <>
            <Text style="contrast-secondary" typography={typography}>
                {formatToReactComponent(trls[canceled ? TrlKeys.canceled : TrlKeys.expire], {
                    '{date}': <HumanDate date={expiredAt} />,
                })}
            </Text>
        </>
    );
};

export default translation(Expire);
